import React from "react";
import PropTypes from "prop-types";
import Modal from "../modals/modal-deprecated";
import ModalFormBase from "./modal-form-base";

const ModalForm = ({ onMount, width, ...props }) => (
  <Modal
    width={width}
    onUnmount={props.onUnmount}
    onMount={onMount}
    onClose={props.onClose}
    closeOnEscape={true}
    closeOnOutsideClick={true}
  >
    <ModalFormBase onClose={props.onClose} {...props} />
  </Modal>
);

ModalForm.defaultProps = {
  onUnmount: () => {},
  onMount: () => {},
  onClose: () => {},
  width: 500,
};

ModalForm.propTypes = {
  onUnmount: PropTypes.func,
  onMount: PropTypes.func,
  onClose: PropTypes.func,
  width: PropTypes.number,
};

ModalForm.displayName = "ModalForm";

export default ModalForm;
